import {
  definitions as CustomerCommunicationDefinitions,
  paths as CustomerCommunicationPaths,
} from '@luxuryescapes/contract-customer-communication';

import { getDayJs } from '~/services/TimeService';
import { request } from '~/services/common';

import { makeCustomerCommunicationV1URL } from './customerCommunicationRequestUtils';

type HeroPlannerSchedulesGetContract =
  CustomerCommunicationPaths['/api/customer-communication/v1/todays-escapes-schedule/hero-planner/schedules/country-groups/{countryGroup}']['get'];

export function mapHeroPlannerSchedulesListItem(
  external: Utils.ArrayElement<
    HeroPlannerSchedulesGetContract['responses']['200']['content']['application/json']['result']
  >,
): CustomerCommunication.HeroPlannerSchedulesListItem {
  const identifiers = external.identifiers;
  const data = external.data as CustomerCommunicationDefinitions['heroDealsScheduleResponseDataSchema'];

  return {
    id: external.scheduleId,
    sendDate: getDayJs(identifiers.sendDate),
    countryGroupId: identifiers.countryGroup,
    countryId: identifiers.country,
    stateId: identifiers.state,
    cityId: identifiers.city,
    segmentId: identifiers.segment,
    cadenceId: identifiers.cadence,
    membershipId: identifiers.loyalty,
    brandId: identifiers.brand,

    emailSubjectLine: data.emailSubjectLine,
    emailPreHeader: data.emailPreheader,
    emailStatus: data.emailStatus,
    emailBannerId: data.emailBannerId,
    emailBannerPosition2Id: data.emailBannerPosition2Id,
    emailHeroDeals: data.emailHeroDeals,
    isApprovedForTpfm: data.isApprovedForTpfm,
    pushTitle: data.pushTitle,
    pushSubtitle: data.pushSubtitle,
    pushMessage: data.pushMessage,
    pushLink: data.pushLink,
    pushStatus: data.pushStatus,
    pushImageId: data.pushImageId,
  };
}

function getSchedulesListUrl(countryGroup: string, countryId?: string, countryState?: string) {
  if (countryId && countryState) {
    return makeCustomerCommunicationV1URL(
      `/todays-escapes-schedule/hero-planner/schedules/country-groups/${countryGroup}/countries/${countryId}/states/${countryState}`,
    );
  }

  return makeCustomerCommunicationV1URL(
    `/todays-escapes-schedule/hero-planner/schedules/country-groups/${countryGroup}`,
  );
}

async function requestGetHeroPlannerSchedulesList(
  brand: string,
  /**
   * YYYY-MM-DD
   */
  startDate: string,
  /**
   * YYYY-MM-DD
   */
  endDate: string,
  countryGroupId: string,
  countryId?: string,
  countryStateId?: string,
) {
  if (!brand) throw 'missing brand';
  if (!countryGroupId) throw 'missing countryGroup';
  if (!startDate) throw 'missing startDate';
  if (!endDate) throw 'missing endDate';

  const url = getSchedulesListUrl(countryGroupId, countryId, countryStateId);
  url.searchParams.set('brand', brand);
  url.searchParams.set('startDate', startDate);
  url.searchParams.set('endDate', endDate);

  return request(url.toString(), {
    method: 'GET',
    credentials: 'include',
  })
    .then((response: HeroPlannerSchedulesGetContract['responses']['200']['content']['application/json']) => {
      return response.result.map(mapHeroPlannerSchedulesListItem);
    })
    .catch((error) => {
      throw JSON.stringify(error, null, 2);
    });
}

export default requestGetHeroPlannerSchedulesList;
